import { Component, Input, OnInit, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'ng-uikit-pro-standard';
import { IDataPanelViewModel } from '../../entities/view-model';

@Component({
  selector: 'app-data-table-pagination',
  templateUrl: './data-table-pagination.component.html',
  styleUrls: ['./data-table-pagination.component.scss']
})
export class DataTablePaginationComponent implements OnInit, AfterViewInit  {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective
  
  constructor(private cdRef: ChangeDetectorRef) { }

  searchText: string = '';

  @Input() vm: IDataPanelViewModel;

  @HostListener('input') oninput() {
    this.searchItems();
  }

  ngOnInit(): void {
    console.log(this.vm);
    this.mdbTable.setDataSource(this.vm.rowsFiltered);
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();
    if (!this.searchText) {
        this.vm.rowsFiltered = [];
        this.vm.rowsFiltered = this.vm.rows;
        this.mdbTable.setDataSource(this.vm.rowsFiltered);
    }
    if (this.searchText) {
      this.vm.rowsFiltered = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(this.vm.rowsFiltered);
    }
}
}
